import React from 'react';
import { useMutation } from '@apollo/client';
import { Button } from '@avila-tek/ui/src';
import { Company } from '../../models';
import { UPDATE_COMPANY_DETAILS } from '../../graphql/mutation';
import { useNotify, useUser } from '../../hooks';
import RegionsInput from './RegionsInput';
import ArrayInput from './StructureInput';
import { SectionTab } from '../navigation';

const tabOptions = [
  {
    label: 'Organización',
    key: 'orga',
  },
  {
    label: 'Regiones',
    key: 'regions',
  },
  {
    label: 'Canales de venta',
    key: 'saleChannels',
  },
];

interface StructureFormProps {
  company?: Company;
}

function StructureForm({ company }: StructureFormProps) {
  const notify = useNotify();
  const [user] = useUser();
  const [disabled, setDisabled] = React.useState(false);
  const [selectedTabOption, setSelectedTabOption] = React.useState<
    'regions' | 'saleChannels' | 'orga'
  >('orga');

  const [structure, setStructure] = React.useState(
    company?.companyDetails?.structure ?? []
  );
  const [regions, setRegions] = React.useState(
    company?.companyDetails?.regions ?? []
  );
  const [saleChannels, setSaleChannels] = React.useState(
    company?.companyDetails?.saleChannels ?? []
  );

  const [updateCompanyDetailsMutation] = useMutation<{
    updateCompanyDetails: Company;
  }>(UPDATE_COMPANY_DETAILS);

  const onSubmit = async (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    e.preventDefault();
    if (disabled) return;
    setDisabled(true);
    try {
      const { data } = await updateCompanyDetailsMutation({
        variables: {
          data: {
            companyId: (user.company as Company)?._id,
            companyDetails: {
              ...company.companyDetails,
              structure,
              regions: regions.map((region) => ({
                ...region,
                __typename: undefined,
              })),
              saleChannels,
              __typename: undefined,
              active: undefined,
              _id: undefined,
            },
          },
        },
      });

      if (data?.updateCompanyDetails?._id) {
        notify('Estructura de la empresa actualizada', 'success');
      }
    } catch (error) {
      notify(error.message, 'error');
    } finally {
      setDisabled(false);
    }
  };

  return (
    <>
      <SectionTab
        options={tabOptions}
        selectedOption={selectedTabOption}
        setSelectedOption={setSelectedTabOption}
      />
      <div className="flex flex-col w-full space-y-10">
        {selectedTabOption === 'orga' ? (
          <ArrayInput
            array={structure}
            setArray={setStructure}
            title="Cargo de sus beneficiarios"
            itemName="Cargo"
            example="Gerente, Vendedor, etc."
          />
        ) : null}
        {selectedTabOption === 'saleChannels' ? (
          <ArrayInput
            array={saleChannels}
            setArray={setSaleChannels}
            title="Métodos de venta"
            itemName="Método de venta"
            example="Presencial, Telefónico, etc."
          />
        ) : null}
        {selectedTabOption === 'regions' ? (
          <RegionsInput regions={regions} setRegions={setRegions} />
        ) : null}
        <div className="flex md:w-1/3 ml-auto">
          <Button onClick={(e) => onSubmit(e)}>Guardar</Button>
        </div>
      </div>
    </>
  );
}

export default StructureForm;
